module.exports = __webpack_public_path__ + "media/images/official/top_mv2_pc_old-beec419854fcf0b17ba1ec4cbcd8bf61.jpg";